export const FETCH_ALL_GAMES = 'FETCH_ALL_GAMES';
export const FETCH_ALL_STUDENT_GAMES = 'FETCH_ALL_STUDENT_GAMES';
export const CREATE_STUDENT_GAME = 'CREATE_STUDENT_GAME';
export const PATCH_STUDENT_GAME = 'PATCH_STUDENT_GAME';
export const DELETE_STUDENT_GAME = 'DELETE_STUDENT_GAME';
